<template>
  <div v-if="selectedNumberOfPlayers == 0">
    <div>Number of Players: <input v-model="playerSelection" /></div>
    <div>Winning Score: <input v-model="winningScore" /></div>
    <div>
      <button @click="selectPlayers">Go</button>
    </div>
  </div>
  <div v-else>
    <div class="optionButton">
      <button @click="clearScores">Clear Scores</button>
      <button @click="resetPlayers">Reset Players</button>
      <button @click="toggleUseScroll"
        :class="toggleScrollButtonStyle">Scroll Scores</button>
    </div>
    <!-- /* Flex Table */ -->
    <div class="f-header">
      <!-- Player Names -->
      <div v-for="player in scoringGrid" :key="player">
        <input v-model="player.name" class="name" />
      </div>
    </div>
    <div class="f-score">
      <!-- Player Scores -->
      <div v-for="player in scoringGrid" :key="player">
        <div
          :class="{
            total:
              player.isWinning == false && player.isCloseToWinning == false,
            totalCloseToWinning: player.isCloseToWinning,
            totalWinning: player.isWinning,
          }"
        >
          {{ player.totalScore }}
        </div>
      </div>
    </div>
    <!-- <div :class="['gameplay-container', {'gameplay-container-scroll': this.useScroll}]"> -->
    <div :class="gameContainerStyle">
      <div v-for="index in currentRowCount" :key="index" class="f-row">
        <div v-for="player in scoringGrid" :key="player" class="f-container">
          <label for="playerScore">
              <input
                id="playerScore"
                v-model="player.score[index - 1]"
                v-on:input="recalculateTotal(player)"
                type="number"
                min="0"
                class="score"
              />
            </label>
        </div>
      </div>
    </div>
    <div class="optionButton">
      <button @click="addRow">Add Row</button>
    </div>
  </div>
</template>

<script>
import FarklePlayer from '../classes/FarklePlayer';

export default {
  name: 'FarkleGame',
  data() {
    return {
      numberOfPlayers: 1,
      playerSelection: 0,
      selectedNumberOfPlayers: 0,
      winningScore: 10000,
      currentRowCount: 5,
      useScoll: false,
      scoringGrid: new Array(FarklePlayer),
    };
  },
  computed: {
    tableWidth() {
      return this.numberOfPlayers * 100;
    },
    gameContainerStyle() {
      if (this.useScoll) {
        return 'gameplay-container-scroll';
      }
      return 'gameplay-container';
    },
    toggleScrollButtonStyle() {
      if (this.useScoll) {
        return 'button-checked';
      }
      return '';
    },
  },
  methods: {
    selectPlayers() {
      if (this.playerSelection > 0) {
        this.selectedNumberOfPlayers = this.playerSelection;
        this.createPlayerGrid(this.selectedNumberOfPlayers);
      }
    },
    createPlayerGrid(players) {
      if (this.selectedNumberOfPlayers > 0) {
        let p = 0;
        while (p < players) {
          this.scoringGrid[p] = new FarklePlayer();
          this.scoringGrid[p].recId = p;
          let s = 0;
          while (s < this.currentRowCount) {
            this.scoringGrid[p].score[s] = '';
            s += 1;
          }
          p += 1;
        }
      }
    },
    addRow() {
      let p = 0;
      while (p < this.selectedNumberOfPlayers) {
        this.scoringGrid[p].score.push('');
        p += 1;
      }
      this.currentRowCount += 1;
    },
    recalculateTotal(player) {
      player.calculateTotalScore();
      player.isPlayerWinning(this.winningScore);
      if (player.score[this.currentRowCount - 1] !== '') {
        this.addRow();
      }
    },
    clearScores() {
      this.currentRowCount = 5;
      let p = 0;
      while (p < this.selectedNumberOfPlayers) {
        this.scoringGrid[p].score = new Array(0);
        let s = 0;
        while (s < this.currentRowCount) {
          this.scoringGrid[p].score[s] = '';
          s += 1;
        }
        this.scoringGrid[p].isCloseToWinning = false;
        this.scoringGrid[p].isWinning = false;
        this.scoringGrid[p].calculateTotalScore();
        p += 1;
      }
    },
    resetPlayers() {
      this.scoringGrid = new Array(FarklePlayer);
      this.selectedNumberOfPlayers = 0;
    },
    toggleUseScroll() {
      this.useScoll = !this.useScoll;
    },
  },
};
</script>

<style scoped>
[class*="f-"] {
  display: flex;
  flex-direction: row;
}

.name {
  background-color: coral;
  font-weight: bold;
  text-align: center;
  width: 80px;
}
.total {
  padding: 3px;
  text-align: center;
}
.totalWinning {
  background-color: lightsalmon;
  color: black;
  padding: 3px;
  text-align: center;
}
.totalCloseToWinning {
  background-color: yellow;
  color: black;
  padding: 3px;
  text-align: center;
}
.score {
  width: 80px;
}
.optionButton {
  text-align: left;
  margin: 5px;
}
button {
  margin-right: 5px;
}
.button-checked {
  margin-right: 5px;
  background-color: salmon;
}

/* flex stuff */
.f-header {
  justify-content: flex-start;
}

.f-header > div {
  width: 100px;
  color: white;
  background: blue;
  margin: 0px;
  padding: 3px;
  border: solid black 1px;
  text-align: center;
}

.f-score {
  justify-content: flex-start;
}

.f-score > div {
  width: 100px;
  color: black;
  background: white;
  margin: 0px;
  padding: 3px;
  border: solid black 1px;
  text-align: center;
}

.f-row {
  justify-content: flex-start;
  margin: 0px;
  padding: 0px;
}

.f-container {
  width: 100px;
  background: aquamarine;
  margin: 0px;
  padding: 3px;
  border: solid black 1px;
  justify-content: center;
}

.gameplay-container {
  margin: 0px;
  padding: 0px;
  overflow-y: auto;
  overflow-x: auto;
}

.gameplay-container-scroll {
  margin: 0px;
  padding: 0px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
